import React from 'react';
import { X } from 'lucide-react';
import { Keyword } from '../../../types/eventDetails.types';

interface KeywordsModalProps {
  keywords: Keyword[];
  isOpen: boolean;
  onClose: () => void;
  primaryColor?: string;
}

export const KeywordsModal: React.FC<KeywordsModalProps> = ({ keywords, isOpen, onClose, primaryColor }) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 z-50"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[80vh] overflow-hidden">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b">
            <h2 className="text-2xl font-semibold text-gray-900">Event Keywords</h2>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <X className="w-5 h-5 text-gray-500" />
            </button>
          </div>
          
          {/* Content */}
          <div className="p-6 overflow-y-auto">
            <div className="flex flex-wrap gap-3">
              {keywords.map((keyword) => (
                <span
                  key={keyword.id}
                  className="inline-flex items-center px-4 py-2 rounded-full text-sm font-medium transition-all hover:shadow-md"
                  style={primaryColor ? {
                    backgroundColor: `${primaryColor}15`,
                    color: primaryColor,
                    border: `1px solid ${primaryColor}30`
                  } : {
                    backgroundColor: '#e5e7eb',
                    color: '#374151',
                    border: '1px solid #d1d5db'
                  }}
                >
                  {keyword.displayName}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};